export default __webpack_public_path__ + "static/media/arrowStorm.faea0905.png";